<template>
  <div class="registration-gst-toggle">
    <v-switch
      :input-value="value"
      @change="$emit('input', $event)"
      label="Show prices before GST"
      color="primary"
      inset dense hide-details
      class="mt-0 pt-0"
    ></v-switch>
  </div>
</template>

<script>
export default {
  name: 'RegistrationGstToggle',
  props: {
    value: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.registration-gst-toggle {
  flex: 0 0 auto;
  padding: 12px 24px;
  border-left: 1px solid #e0e0e0;
  text-align: right;
}
.registration-gst-toggle ::v-deep .v-input--selection-controls__input {
  order: 2;
  margin-left: 12px;
  margin-right: 0;
}
.registration-gst-toggle ::v-deep .v-label {
  font-size: 14px;
}
@media (max-width: 599px) {
  .registration-gst-toggle { border-left: 0; padding: 12px 16px; }
}
</style>
